import { DEMO_CURSOR_TRAVEL_MS } from '../jsm-playground-demo-cursor';

export const DEMO_CURSOR_LABEL = 'Adam';

const PRESS_MS = 200;
const ARRIVE_AND_PRESS = DEMO_CURSOR_TRAVEL_MS + 150;
const CURSOR_FADE_MS = 400;

const buttonPress = 500 + ARRIVE_AND_PRESS;
const bannerSwatchMove = buttonPress + PRESS_MS + 400;
const bannerSwatchPress = bannerSwatchMove + ARRIVE_AND_PRESS;
const iconSwatchMove = bannerSwatchPress + PRESS_MS + 300;
const iconSwatchPress = iconSwatchMove + ARRIVE_AND_PRESS;
const cursorHide = iconSwatchPress + PRESS_MS + 600;
const cardApproachJump = cursorHide + CURSOR_FADE_MS;
const articleCardMove = cardApproachJump + 300;
const articleCardPress = articleCardMove + ARRIVE_AND_PRESS;

export const HUB_DEMO = {
	cursorIn: 500,
	buttonPress,
	buttonRelease: buttonPress + PRESS_MS,
	bannerSwatchMove,
	bannerSwatchPress,
	bannerSwatchRelease: bannerSwatchPress + PRESS_MS,
	iconSwatchMove,
	iconSwatchPress,
	iconSwatchRelease: iconSwatchPress + PRESS_MS,
	cursorHide,
	cardApproachJump,
	articleCardMove,
	articleCardPress,
	articleCardRelease: articleCardPress + PRESS_MS,
	cursorOut: articleCardPress + PRESS_MS + 500,
} as const;

const askPillPress = 1600 + ARRIVE_AND_PRESS;

export const ARTICLE_DEMO = {
	cursorIn: 1600,
	askPillPress,
	askPillRelease: askPillPress + PRESS_MS,
	cursorOut: askPillPress + PRESS_MS + 500,
} as const;
